import { createSlice } from "@reduxjs/toolkit";

const diamondSlice = createSlice({
    name:"diamonds",
    initialState:{
        diamonds:null
    },
    reducers:{
        setDiamondList(state,action){
            state.diamonds = action?.payload;
        },
    }
})


export const {setDiamondList} = diamondSlice.actions
export default diamondSlice.reducer